// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accent":"-Ibb7f","accent-small":"_3_lrZT"};